import styled from 'styled-components';
import { NavLink } from '@minerva-analytics/pantheon';
import Image from 'components/Image';
import { BLACK, ORANGE, BLUE } from 'root/theme';

const NotificationContainer = styled.div`
  display: flex;
  justify-content: space-between;
  flex: 0 100%;
  align-items: ${(props) => props.renderedInMenu ? `flex-start` : `center`};
  margin: 10px 0 10px 0;
  padding: 0.25rem;
  cursor: pointer;
`;

const NotificationLink = styled(NavLink)`
  display: flex;
  flex: 0 100%;
  justify-content: space-between;
  text-decoration: none;
  color: ${BLACK};
  align-items: inherit;

  &:hover {
    color: ${BLUE};
    cursor: pointer;
  }
`;

const NotificationInfo = styled.div`
  display: flex;
  align-items: inherit;
`;

const NotificationText = styled.div`
  margin-left: 1rem;
  display: inline-block;
  text-align: left;
  word-break: break-word;

  ${(props) =>
    props.newNotif ? `
      font-weight: 600;
      color: ${ORANGE};`
      : `color: ${BLACK}
  `}

  &:hover {
    color: ${BLUE};
    cursor: pointer;
  }
`;

const NotificationImage = styled(Image)`
  border-radius: 50%;
  height: ${(props) => props.renderedInMenu ? `40px` : `100px`};
  width: ${(props) => props.renderedInMenu ? `40px` : `100px`};
  min-width: ${(props) => props.renderedInMenu ? `40px` : `100px`};
`;

const NotificationName = styled.p`
  font-size: 1rem;
  color: inherit;
`;

const NotificationDate = styled.p`
  color: ${BLACK};
  font-weight: normal;
  margin-top: ${(props) => props.renderedInMenu ? `0` : `10px`};
`;

const ArrowsXs = styled.div`
  display: flex;
  font-size: inherit;
  font-weight: 600;
  justify-content: space-between;
  min-width: ${(props) => !props.isStatic && props.renderedInMenu ? `10px` : `20px`};
  margin: 2px 0px 0px 12px;
  color: ${(props) => props.isCircle ? `${BLACK}` : `inherit`};

  @media (max-width: 414px) {
    margin: 2px 0px 0px 10px;
  }

  &:hover {
    color: ${BLUE};
    cursor: pointer;
  }
`;


export {
  NotificationContainer,
  NotificationDate,
  NotificationImage,
  NotificationInfo,
  NotificationName,
  NotificationText,
  NotificationLink,
  ArrowsXs,
};
